import React from "react";

export const SpacerListMenuItem: React.FunctionComponent = (): JSX.Element => {
    return (
        <br/>
    );
};
